import styled from 'styled-components';

export const FaqSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  width: 100%;
  max-width: 46rem;

  text-align: center;
`;

export const FaqList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  text-align: left;
`;
